const keys = {
  POR_COTACAO: {
    key: 'POR_COTACAO',
    description: 'Por cotação',
  },
  POR_PRODUTO: {
    key: 'POR_PRODUTO',
    description: 'Por produto',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
